const ajaxErrorHandling = require('../components/ajaxErrorHandling');

function convertNumToPrice(num) {
    // 小数点2桁、整数は3桁カンマ区切りに変換
    return num.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

function ordSuffix(no) {
    // no = 0 => index = 1
    // no = 1 => index = 2
    const index = no + 1;
    switch (index) {
        case 1: return index + 'st';
        case 2: return index + 'nd';
        case 3: return index + 'rd';
        default: return index + 'th';
    }
}

function createTBody(installmentTable){
    // 商品ID
    const pid = $('#product-id').val();
    // 商品単価
    const productPrice = $('#product-price').val();
    // デポジットの金額
    const deposit = $('#deposit').val();
    // 支払日
    const paymentDate = $('#payment-date').val();
    // 配送料
    const shippingFee = $('input[name=modal-installment-radio]:checked').val();
    // 分割回数
    const paymentNumber = $('#number-of-payment').val();
    // 合計金額
    const total = convertNumToPrice(parseFloat(productPrice) + parseFloat(shippingFee));

    // 商品単価からデポジットを抜いた総額（これが分割金額の計算に利用される値）
    const totalSubtractDeposit = parseFloat(productPrice) - deposit;

    // テーブル情報
    const table = document.getElementById('installment-simulator');
    // tBodyの取得
    const oldtBody = table.tBodies;
    // tBodyの削除
    for (let i = 0; i < oldtBody.length; i++) {
        while (oldtBody[i].rows.length > 0) {
            oldtBody[i].deleteRow(0);
        }
    }

    // tBodyの生成
    const tbody = table.createTBody();

    // デポジットを考慮した分割回数
    const NumOfDeductedDeposit = Number(deposit) > 0 ? paymentNumber - 1 : paymentNumber;
    // デポジットと最終回を考慮した分割回数
    const NumOfDeductedDepositAndFinal = Number(deposit) > 0 ? paymentNumber - 2 : paymentNumber - 1;

    // Waitlist判定フラグ
    const isWaitlist = $('#is-waitlist').val();

    if(Number(deposit) > 0) {
        // デポジット分のテーブル更新
        const tr = tbody.insertRow(-1);
        const td1 = tr.insertCell(0);
        const td2 = tr.insertCell(1);
        const td3 = tr.insertCell(2);
        td3.className = 'amount';
        td1.appendChild(document.createTextNode('1st Deposit'));
        if (isWaitlist === 'true') {
            td2.appendChild(document.createTextNode('Selected'));
        } else {
            td2.appendChild(document.createTextNode('Today'));
        }
        td3.appendChild(document.createTextNode('$' + deposit));
    }

    // 分割払い分のテーブル更新
    for (let i = 0; i < NumOfDeductedDeposit; i++) {
        const tr = tbody.insertRow(-1);
        const td1 = tr.insertCell(0);
        const td2 = tr.insertCell(1);
        const td3 = tr.insertCell(2);
        td3.className = 'amount';
        td1.appendChild(document.createTextNode(installmentTable[i].ord));
        if (i === NumOfDeductedDepositAndFinal){
            // 分割支払の最終回の場合
            td2.rowSpan = 2;
            td2.appendChild(document.createTextNode('On Shipment'));
        } else {
            // 最終回以外の場合
            td2.appendChild(document.createTextNode(installmentTable[i].paymentDay));
        }
        td3.appendChild(document.createTextNode('$' + Number(installmentTable[i].amount)));
    }
    // 合計行の生成
    // Shipping Fee
    let tr = tbody.insertRow(-1);
    let td1 = tr.insertCell(0);
    td1.appendChild(document.createTextNode('Shipping Fee'));
    let td2 = tr.insertCell(1);
    td2.appendChild(document.createTextNode('$' + shippingFee));
    td2.className = 'amount';
    // 最終行
    tr = tbody.insertRow(-1);
    tr.className = 'total';
    td1 = tr.insertCell(0);
    td1.colSpan = 2;
    td1.appendChild(document.createTextNode('Total'));
    td2 = tr.insertCell(1);
    td2.className = 'amount';
    // 合計金額は、①商品単価 + ②配送料
    td2.appendChild(document.createTextNode('$' + total));
}

function updateTable() {
    const url = $('#update-install-simulator').val();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                pid: $('#product-id').val(),
                numberOfPayments: $('#number-of-payment').val(),
                dateOfPayment: $('#payment-date').val()
            },
            success: function (data) {
                createTBody(data.installmentTable);
            },
            error: function (err) {
                ajaxErrorHandling(err);
            }
        });
}

$(() => {
    // 支払日変更時
    $('body').on('change', '#payment-date', function () {
        updateTable();
    });
    // 支払い回数変更時
    $('body').on('change', '#number-of-payment', function () {
        updateTable();
    });
    // 配送方法変更時
    $('body').on('change', 'input[type=radio][name="modal-installment-radio"]', function () {
        updateTable();
    });
});
